import React from 'react';

const SurveyWebContent: React.FC<{ data: string }> = ({ data }) => {
    return <div dangerouslySetInnerHTML={{ __html: data }} style={{padding: "12px 0"}}></div>;
};

export default SurveyWebContent;
